module.exports = __webpack_public_path__ + "img/report_background_two.6c8b31fa.png";